# Dictaphone seeds
# Clips are created through the recording interface
puts "Dictaphone ready - start recording!"
